<div class="flex-container">
<div class="main-flex-column" *ngIf="portfolioModel?.profileData?.isStock || portfolioModel?.profileData?.isBalanced">
<div>   
<p class="main-title">Equity</p>
<div>
    <!-- <p>Portfolio emphasizing U.S. and foreign large- and mid-capitalization value stocks.</p> -->
    <p class="hidetext-screenreader-only">{{styleBoxEquity}}</p>
</div>
</div>
<div class="parent">
<div class="push-down chart-padding-right" aria-hidden=true>
        <div class="title-wrapper">     
    <p class="rotate title-tag">Market capitalization</p>  
    </div>
    <div class="rotated-column">
    <span class="gap-25-mobi font-size-14">Large</span>
    <span class="gap-25-mobi font-size-14">Mid</span>
    <span class="gap-15-mobi font-size-14">Small</span>
    </div> 
</div> 
<div>
<div style="flex-direction:column-reverse" class="surround-top-center" aria-hidden=true>
    <div class="top-flex">
    <div class="top-centers">
    <p class="title-tag">Investment style</p>
    </div>
    <div class="top-centers">
        <p class="font-size-14">Value</p>
        <p class="blend-pad font-size-14">Blend</p>
        <p class="growth-pad font-size-14">Growth</p>
    </div>   
</div>
    <div style="padding-left: 20px; margin-bottom: 80px;" class="grid-container center-flex">
        <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.equityInvestmentStyleId === '1' }" class="grid-item stockbondstylebox-top-title-extend" style="border-left: none; border-top: none !important;"></div>
        <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.equityInvestmentStyleId === '2' }" class="grid-item stockbondstylebox-top-title-extend" style="border-top: none !important;"></div>
        <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.equityInvestmentStyleId === '3' }" class="grid-item stockbondstylebox-top-title-extend" style="border-right: none; border-top: none !important;" ></div>
        <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.equityInvestmentStyleId === '4' }"  class="grid-item" style="border-left: none !important;"></div>
        <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.equityInvestmentStyleId === '5' }"  class="grid-item"></div>
        <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.equityInvestmentStyleId === '6' }"  class="grid-item" style="border-right: none !important;"></div>  
        <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.equityInvestmentStyleId === '7' }"  class="grid-item" style="border-left: none; border-bottom: none !important;"></div>
        <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.equityInvestmentStyleId === '8' }"  class="grid-item" style="border-bottom: none !important;"></div>
        <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.equityInvestmentStyleId === '9' }"  class="grid-item" style="border-right: none; border-bottom: none !important;"></div>
    </div>
</div>
</div>
</div>
</div>
<div class="main-flex-column" *ngIf="((portfolioModel?.profileData?.isBond && !portfolioModel?.profileData?.isInternational) || portfolioModel?.profileData?.isBalanced) && portfolioModel?.profileData?.fixedIncomeInvestmentStyleId">
    <div>    
        <p class="main-title">Fixed Income</p>
       
        <!-- <div class="equity-description">
             <p>Diversified portfolio of U.S. and foreign intermediate-term, investment-grade bonds.</p>
        </div> -->
    </div>
    <div class="parent">
        <div class="push-down chart-padding-right">       
                <div class="title-wrapper fi-mobile-height fi-mobile-title">     
                <p class="rotate title-tag">Quality</p>
                </div>
                <div class="rotated-column fixed-income-gap fi-mobile-rotated">
                <span class="gap-30 font-size-14">Trsy/<br>Agcy</span>
                <span class="gap-25 font-size-14">Inv Grd<br>Corp</span>
                <span class="gap-20 font-size-14">Below<br>Inv<br>Grade</span>
                </div> 
            </div> 
        
<div style="flex-direction:column-reverse" class="surround-top-center">
    <div class="top-flex">
        <div class="top-centers">
            <p class="title-tag">Duration</p>
            </div>
            <div class="top-centers">
                <p class="font-size-14">Short</p>
                <p class="med-pad font-size-14">Medium</p>
                <p class="long-pad font-size-14">Long</p>
            </div>
</div>
            <div style="padding-left: 20px;" class="grid-container center-flex">
                <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.fixedIncomeInvestmentStyleId === '1' }" class="grid-item stockbondstylebox-top-title-extend" style="border-left: none; border-top: none !important;"></div>
                <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.fixedIncomeInvestmentStyleId === '2' }" class="grid-item stockbondstylebox-top-title-extend" style="border-top: none !important;"></div>
                <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.fixedIncomeInvestmentStyleId === '3' }" class="grid-item stockbondstylebox-top-title-extend" style="border-right: none; border-top: none !important;" ></div>        
                <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.fixedIncomeInvestmentStyleId === '4' }"  class="grid-item" style="border-left: none !important;"></div>
                <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.fixedIncomeInvestmentStyleId === '5' }"  class="grid-item"></div>
                <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.fixedIncomeInvestmentStyleId === '6' }"  class="grid-item" style="border-right: none !important;"></div>  
                <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.fixedIncomeInvestmentStyleId === '7' }"  class="grid-item" style="border-left: none; border-bottom: none !important;"></div>
                <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.fixedIncomeInvestmentStyleId === '8' }"  class="grid-item" style="border-bottom: none !important;"></div>
                <div [ngClass]="{'grid-background-color': portfolioModel?.profileData?.fixedIncomeInvestmentStyleId === '9' }"  class="grid-item" style="border-right: none; border-bottom: none !important;"></div>            
            </div>
        </div>
    </div>
</div>
